export default __webpack_public_path__ + "static/media/image.a-t-labs.9fb771f1.png";